module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.courseAlerts) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.alertCount))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Course Alerts"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find your time sensitive course alerts below'),
      expression: "'Find your time sensitive course alerts below'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.courseAlerts && _vm.courseAlerts.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.courseAlerts), function(alert) {
    return _c('li', [_c('a', {
      attrs: {
        "href": alert.link
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [(alert.meetingId) ? _c('span', {
      staticClass: "alert-name"
    }, [_vm._v("Weekly Update")]) : _c('span', {
      staticClass: "alert-name"
    }, [_vm._v(_vm._s(alert.name))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("shortDate")(alert.dueDate))), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": alert.dueDate
      }
    })], 1)])])
  })) : _c('p', [_vm._v("No alerts at this time")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26c76929!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SupervisorAlerts.vue
// module id = 1998
// module chunks = 2